export const TileTypeRarity = {
    /**
     * @constant
     * @type {number}
     */
    UNSET: 0,
    /**
     * @constant
     * @type {number}
     */
    COMMON: 1,
    /**
     * @constant
     * @type {number}
     */
    ORE: 2,
    /**
     * @constant
     * @type {number}
     */
    GOLD: 3,
    /**
     * @constant
     * @type {number}
     */
    UPGRADE: 4,
    /**
     * @constant
     * @type {number}
     */
    RUBY: 5
}